import * as yup from 'yup';
export const loginValidationSchema = yup.object({
    name: yup
        .string('Enter the device name')
        .required('Device name is required'),
    password: yup
        .string('Enter the password')
        .min(6, 'The password must be at least 6 characters')
        .required('Password is required'),
});